import { createRouter } from "@tanstack/solid-router";
import { pluginRoutes } from "@/composition";
import { rootRoute } from "@/routes/__root";
import { indexRoute } from "@/routes/home";
import { conversationRoute } from "@/routes/conversation";
import { settingsFontsRoute } from "@/routes/settings-fonts";
import { settingsAccountRoute } from "@/routes/settings-account";
import { settingsBackupRoute } from "@/routes/settings-backup";
import { NotFoundRoute } from "@/components/not-found-route";

const routeTree = rootRoute.addChildren([
  indexRoute,
  ...pluginRoutes,
  conversationRoute,
  settingsFontsRoute,
  settingsAccountRoute,
  settingsBackupRoute,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  defaultNotFoundComponent: NotFoundRoute,
});

declare module "@tanstack/solid-router" {
  interface Register {
    router: typeof router;
  }
}
